export interface RoutePresentation {
  visiblePath: string;
  pending: boolean;
}

/** Keep the last committed route visible until its replacement styles are ready. */
export function getRoutePresentation(committedPath: string, requestedPath: string): RoutePresentation {
  return {
    visiblePath: committedPath || requestedPath,
    pending: committedPath !== '' && committedPath !== requestedPath,
  };
}
